import { render, staticRenderFns } from "./SpextDocs.vue?vue&type=template&id=9482f574&scoped=true&"
import script from "./SpextDocs.vue?vue&type=script&lang=js&"
export * from "./SpextDocs.vue?vue&type=script&lang=js&"
import style0 from "./SpextDocs.vue?vue&type=style&index=0&id=9482f574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9482f574",
  null
  
)

export default component.exports